import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-ranking-rating-report',
  templateUrl: './ranking-rating-report.component.html',
  styleUrls: ['./ranking-rating-report.component.scss']
})
export class RankingRatingReportComponent implements OnInit {
  @ViewChild('targetTable') targetTable: ElementRef;
  
  rankingReportExport: MenuItem[];
  rankingReportDrillDownExport: MenuItem[];
  
  public userId: string;
  public rankingReportData: any = [];
  public rankingReportWithFilteredVal: any = [];
  public rankingReportWithFilteredValTable: any = [];

  public loading: boolean = false;
  public subscriptions: any = [];

  public subjectSub: any;

  scrollHeight: any = '130px';
  scrollHeightDD: any = '130px';
  date: any;

  dataForFilterDropdown: any = [];
  selectedFilterVal: any;

  selectedUserRole: any;
  userRoleList: any = [];
  selectedUserId: any;
  userIdList: any = [];
  selectedUserAction: any;
  userActionList: any = [];

  rankingReportDrillDownData: any = [];

  constructor(
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    this.date = new Date();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadData(this.userId);

    this.rankingReportExport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.rankingReportWithFilteredVal, `Ranking_Report_${this.date}`);
        },
      }
    ];
    this.rankingReportDrillDownExport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelDrillDown(this.rankingReportDrillDownData, `Ranking Report DrillDrown Data${this.date}`);
        },
      }
    ];
  }

  onSelectUserRoleList(){
    this.rankingReportWithFilteredValTable = [];
    this.userIdList = [];
    this.selectedUserId = null;
    this.userActionList = [];
    this.selectedUserAction = null;


    this.rankingReportWithFilteredValTable = this.rankingReportData.filter(item => {
      return item.UserRole == this.selectedUserRole?.name
    });

    this.userIdList = this.getUniqueUserId(this.rankingReportData);
  }

  onSelectUserIdList(){
    // this.rankingReportWithFilteredValTable = [];
    this.userActionList = [];
    this.selectedUserAction = null;

    this.rankingReportWithFilteredValTable = this.rankingReportData.filter(item => {
      return item.UserID_UserDetail == this.selectedUserId?.name && item.UserRole == this.selectedUserRole?.name
    });

    this.userActionList = this.getUniqueUserAction(this.rankingReportData);

  }

  onSelectUserActionList(){
    this.rankingReportWithFilteredValTable = this.rankingReportData.filter(item => {
      return item.Action_Type == this.selectedUserAction?.name && item.UserID_UserDetail == this.selectedUserId?.name && item.UserRole == this.selectedUserRole?.name
    });
  }

  // onSelectMIConsFilter(){
  //   if(this.selectedFilterVal != null){
  //     this.rankingReportWithFilteredVal = this.rankingReportData.filter(item => {
  //       return item.filterCol == this.selectedFilterVal?.actionLevel
  //     });
  //   }else{
  //     this.rankingReportWithFilteredVal = this.rankingReportData;
  //   }
  // }

  loadData(userId) {
    this.loading = true;
    let sub = this.deptDashBoardService
      .getAllUserRanking()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data?.length > 0) {
            if(data?.length == 1) {
              this.scrollHeight = '180px';
            }else if(data?.length <=5) {
              this.scrollHeight = '300px';
            }else{
              this.scrollHeight = '400px';
            }

            data = data.map((val)=> ({
              ...val,
              UserID_UserDetail : `${val?.UserID}- ${val?.User_detail}`,
              Rating_Start: val?.Ranking_Ve == 'Very Poor' ? 0 : val?.Ranking_Ve == 'Poor' ? 1 : val?.Ranking_Ve == 'Average' ? 2 : val?.Ranking_Ve == 'Good' ? 3 : val?.Ranking_Ve == 'Very Good' ? 4 : val?.Ranking_Ve == 'Outstanding' ? 5 : 0
            }))
            this.rankingReportData = data;

            this.userRoleList = this.getUniqueUserRole(data);
          }else{
            this.rankingReportData = [];
            this.rankingReportWithFilteredVal = [];
            this.scrollHeight = '130px';
          }
          this.activityRecordService.activityRecord(this.userId, 'Ranking Report', '', new Date(), 'Success');
        },
        error: (err) => {
          this.rankingReportData = [];
          this.rankingReportWithFilteredVal = [];
          this.scrollHeight = '130px';
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Ranking Report Error', '', new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  loadDrillDownData(row) {
    this.loading = true;
    let sub = this.deptDashBoardService
      .getUserRankingByActionUser(row?.Action_Type, row?.UserRole, row?.UserID)
      .pipe(first())
      .subscribe({
        next: (data) => {
          setTimeout( () => this.targetTable.nativeElement.scrollIntoView({
            block: "center",
            behavior: "smooth"
          }), 400)
          
          this.loading = false;
          if (data?.length > 0) {
            if(data?.length == 1) {
              this.scrollHeightDD = '180px';
            }else if(data?.length <=5) {
              this.scrollHeightDD = '300px';
            }else{
              this.scrollHeightDD = '400px';
            }
         
            this.rankingReportDrillDownData = data;

          
          }else{
            this.rankingReportDrillDownData = [];

            this.scrollHeightDD = '130px';
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
          this.activityRecordService.activityRecord(this.userId, 'Ranking Report DrillDown', '', new Date(), 'Success');
        },
        error: (err) => {
          setTimeout( () => this.targetTable.nativeElement.scrollIntoView({
            block: "center",
            behavior: "smooth"
          }), 400)

          this.rankingReportDrillDownData = [];

          this.scrollHeightDD = '130px';
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Ranking Report DrillDown Error', '', new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getUniqueUserRole(data) {
    const actionLevelSet = new Set(data.map(entry => entry.UserRole));
    const actionLevelObjects = Array.from(actionLevelSet).map(name => ({ name }));
    return actionLevelObjects;
  }

  getUniqueUserId(data) {
    const filteredData = data.filter(item => item.UserRole == this.selectedUserRole?.name);

    const actionLevelSet = new Set(filteredData.map(entry => entry.UserID_UserDetail));

    const actionLevelObjects = Array.from(actionLevelSet).map(name => ({ name }));

    return actionLevelObjects;
    // const actionLevelSet = new Set(data.map(entry => entry.UserID_UserDetail));
    // const actionLevelObjects = Array.from(actionLevelSet).map(name => ({ name }));
    // return actionLevelObjects;
  }

  getUniqueUserAction(data) {
    const filteredData = data.filter(item => item.UserID_UserDetail == this.selectedUserId?.name && item.UserRole == this.selectedUserRole?.name);

    const actionLevelSet = new Set(filteredData.map(entry => entry.Action_Type));

    const actionLevelObjects = Array.from(actionLevelSet).map(name => ({ name }));

    return actionLevelObjects;

    // const actionLevelSet = new Set(data.map(entry => entry.Action_Type));
    // const actionLevelObjects = Array.from(actionLevelSet).map(name => ({ name }));
    // return actionLevelObjects;
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Role' : d?.UserRole,
          'User ID' : d?.UserID,
          'Action' : d?.Action_Type,
          'User Detail' : d?.User_detail,
          'No.s Of App' : d?.Nos_of_action,
          'Max Score' : d?.Max_rank,
          'Obtained Score' : d?.Obtained_Rank_with_Ve,
          'Obtained Percentage' : d?.Per_Obtained_Rank_with_Ve,
          'Rating' : d?.Ranking_Ve,
          'Rating Star' : d?.Rating_Start,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  exportExcelDrillDown(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Role' : d?.UserRole,
          'Application Id' : d?.appid,
          'Action' : d?.Action_Type,
          'User Detail' : d?.User_detail,
          'Assigned Date' : d?.AssignedDate,
          'Action Date' : d?.Action_Date,
          'Days Taken' : d?.Days_Taken,
          'Target Days' : d?.TargetDays
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onSelectRow(item){
    this.loadDrillDownData(item);
  }

  getColorForRanking(rank: number) {
    if(rank == 0){
      return '#E58788'; // very poor
    }else if(rank == 1){
      return '#DDB7E8'; // poor
    }else if(rank == 2){
      return '#DFD0B0'; // average
    }else if(rank == 3){
      return '#F9ECB9'; // Good 
    }else if(rank == 4){
      return '#D2E27E'; // Very Good
    }else if(rank == 5){
      return '#A5ED89'; // Outstanding
    }else{
      return '#FFFFF'; // Default
    }
  }
  
}
